import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon } from 'semantic-ui-react';
import { format } from 'date-fns';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import { getInvoiceType, getSubscriptionPeriod } from './discountRuleUtils';

class DiscountRulesList extends React.Component {
  renderTableContent() {
    const { isLoading, discountRules } = this.props;

    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="9">
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (discountRules.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="9" style={{ textAlign: 'center' }}>
            No discount rules found
          </Table.Cell>
        </Table.Row>
      );
    }

    return discountRules.map(this.renderTableRow.bind(this));
  }

  renderTableRow(rule) {
    const { onEditRule, onDeleteRule } = this.props;
    const invoiceType = getInvoiceType(rule.rules);
    const subscriptionPeriod = getSubscriptionPeriod(rule.rules);

    return (
      <Table.Row key={rule.id}>
        <Table.Cell>{rule.name}</Table.Cell>
        <Table.Cell>{invoiceType || '-'}</Table.Cell>
        <Table.Cell>{rule.discount_percentage}%</Table.Cell>
        <Table.Cell>{rule.priority}</Table.Cell>
        <Table.Cell>
          {subscriptionPeriod != null ? subscriptionPeriod : '-'}
        </Table.Cell>
        <Table.Cell>
          {rule.created_at
            ? format(new Date(rule.created_at), 'yyyy-MM-dd HH:mm:ss')
            : '-'}
        </Table.Cell>
        <Table.Cell>
          {rule.updated_at
            ? format(new Date(rule.updated_at), 'yyyy-MM-dd HH:mm:ss')
            : '-'}
        </Table.Cell>
        <Table.Cell>
          <Icon
            name="pencil"
            link
            color="blue"
            onClick={() => onEditRule(rule)}
            style={{ marginRight: '1em', cursor: 'pointer' }}
          />
          <Icon
            name="trash"
            link
            color="red"
            onClick={() => onDeleteRule(rule)}
            style={{ cursor: 'pointer' }}
          />
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Discount Type</Table.HeaderCell>
            <Table.HeaderCell>Discount Percentage</Table.HeaderCell>
            <Table.HeaderCell>Priority</Table.HeaderCell>
            <Table.HeaderCell>Months Left</Table.HeaderCell>
            <Table.HeaderCell>Created</Table.HeaderCell>
            <Table.HeaderCell>Updated</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderTableContent()}</Table.Body>
      </Table>
    );
  }
}

DiscountRulesList.propTypes = {
  discountRules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      rules: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string,
          operator: PropTypes.string,
          value: PropTypes.array,
        })
      ),
      discount_percentage: PropTypes.number,
      priority: PropTypes.number,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onEditRule: PropTypes.func.isRequired,
  onDeleteRule: PropTypes.func.isRequired,
};

export default DiscountRulesList;
